export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13290.8acb5e86.jpg";